module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAEElEQVQYlWNgGBrg/1BQAADubQT8sPMjLQAAAABJRU5ErkJggg=="